import { Platform } from '@angular/cdk/platform';
import { NgTemplateOutlet } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  HostBinding,
  ChangeDetectorRef,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

import { Option } from '../interfaces/option.interface';

@Component({
  selector: 'mb-select',
  templateUrl: './select.component.html',
  styleUrls: ['./../dropdown/dropdown.component.scss', './select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, FormsModule, TranslatePipe],
})
export class SelectComponent {
  private cdr = inject(ChangeDetectorRef);
  private platform = inject(Platform);

  @Input() useNativeSelect: boolean | undefined;

  @HostBinding('class.open-top')
  @Input()
  openTop = false;

  @Input() hideLabel = false;
  @Input() dropdown = true;

  @HostBinding('class.is-open')
  public isOpen = false;

  public valueLabel: string = '';
  @Input() icon: string = '';

  @Input() options: Option[] = [];

  private _value: any;
  @Input()
  set value(v: any) {
    this.setValue(v);
  }
  get value() {
    return this._value;
  }

  @Output() selectionChanged = new EventEmitter<Option[]>();

  constructor() {
    if (this.useNativeSelect === undefined) {
      this.useNativeSelect = this.platform.IOS || this.platform.ANDROID;
    }
  }

  public open(e: MouseEvent) {
    const docClickFn = () => {
      this.isOpen = false;
      this.cdr.detectChanges();
      document.removeEventListener('click', docClickFn);
    };

    if (this.isOpen) {
      docClickFn();
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    this.isOpen = true;
    this.cdr.detectChanges();
    document.addEventListener('click', docClickFn);
  }

  public nativeOptionSelect(event: any) {
    const options = event.target.options;
    for (var i = 0, iLen = options.length; i < iLen; i++) {
      const opt = options[i];
      const option = this.options.find((option) => option.value === opt.value) as Option;
      if (option) {
        option.selected = !!opt.selected;
      }
    }
    this.optionSelected(event);
  }

  public optionSelected(event: any, option?: Option) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (option) {
      option.selected = !option.selected;
    }
    this.cdr.detectChanges();
    this.selectionChanged.emit(this.options);
  }

  private setValue(v: any) {
    this._value = v;
    const foundValue = this.options.find((option) => option.value === v);
    if (foundValue) {
      this.valueLabel = foundValue.label;
    } else {
      this.valueLabel = v;
    }
  }
}
